module.exports = __webpack_public_path__ + "static/img/HYGR_Logo_White.2d9f878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/HYGR_Logo_White.png
// module id = 0g1m
// module chunks = 0